import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';

import { Moneda } from '../model/moneda';
import { UtilitiesService } from '../services/utilities.service'



@Injectable()
export class MonedaService {

   private monedasResult: Observable<Moneda[]>;

  constructor(
    private _http: Http,
    private _utilities:UtilitiesService

  ) { }


 
  getMonedas() : Observable<Moneda[]> {
    
    let json = {   "Metodo": "getMoneda",   "Datos":  {}};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
    
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());
   }


  getMoneda() : Observable<Moneda[]> {  

		return this._http.get("http://localhost:8080/API_3PL/web/api/getMonedas").map(res => res.json());

   }


}
 


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/moneda.service.ts